/* 
These functions make sure WordPress 
and Foundation play nice together.
*/
jQuery(document).ready(function() {
    
    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();
    
	 // Makes sure last grid item floats left
	jQuery('.archive-grid .columns').last().addClass( 'end' );
	
	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').wrap("<div class='flex-video'/>");

			


	var themeLayout = jQuery('body').attr('data-theme-layout');

	jQuery('.hero-slider').slick({
		infinite: false,
		dots: true,
		arrows: false,
		infinite: true,
		draggable: false,
		autoplay: false,
		autoplaySpeed: 6000,
		fade: true
	});
	
	var headerHeight = jQuery('.header').height()+"px";
	var htmlMarginTop = jQuery('html').css("margin-top");
	
	if( jQuery('body').hasClass('sticky-header') && !jQuery('body').hasClass('admin-bar') ) {	    
	    jQuery('.off-canvas-content').css({'padding-top': headerHeight });
	    jQuery('.sticky-header .header').css({'top': htmlMarginTop });
	}
	
	jQuery( window ).resize(function() {
	    
	    var headerHeight = jQuery('.header').height()+"px";
	    var htmlMarginTop = jQuery('html').css("margin-top");
        
        if( jQuery('body').hasClass('sticky-header') && !jQuery('body').hasClass('admin-bar') ) {    	    
    	    jQuery('.off-canvas-content').css({'padding-top': headerHeight });
    	    jQuery('.sticky-header .header').css({'top': htmlMarginTop });
	    }
	    
    });
	

	

	   jQuery('.hero-gallery-slides').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        infinite: true,
        autoplay: true,
        arrows: false,
        asNavFor : '.hero-gallery-slides-thumb',
        fade : true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 641,
                settings: {
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    dots: false,
                    arrows: false,
                    speed: 400,
                    autoplaySpeed: 6000,
                    asNavFor : '.hero-gallery-slides-thumb',
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    asNavFor : '.hero-gallery-slides-thumb',
                }
            }
    
         ]


    });

    jQuery('.hero-gallery-slides-thumb').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        asNavFor : '.hero-gallery-slides',
        centerMode : false,
        focusOnSelect: true
    });


	
	function generate_carousel( elem, param, $infinite = "yes" ) {
	    
	    var sm = 1, md = 1, lg = 1;
	     var parent_section = elem.closest('.page-element');
	     var showDots = parent_section.hasClass('show-carousel-dots') ? true : false;
	     var custom_slidesToScroll = parent_section.hasClass('slidesToScroll_3') ? 3 : 1;
	    
        switch( param ) {
            case 'medium-6':
                md = 2;
                lg = 2;
            break;
            
            case 'medium-4':
                md = 2;
                lg = 3;
            break;    

            case 'medium-6 large-4':
				md = 2;
                lg = 3;
            break;               	
            
            case 'medium-6 large-3':
                md = 2;
                lg = 4;
            break;

            case 'medium-4 large-2':
                md = 2;
                lg = 6;
            break;
        }
        
		var infinite_value = $infinite == "yes" ? true : false;
        
        if(elem.data('element') == 'testimonials') {
            
             elem.slick({
        		dots: true,
        		arrows: false,
        		infinite: infinite_value,
        		draggable: false,
        		autoplay: true,
        		slidesToShow: lg,
        		slidesToScroll: 1,
        		autoplaySpeed: 6000,
        			responsive:[
        		 		{
        		 			breakpoint: 641, 
        		 				settings: {
        			        		 infinite: true,
        			        		 slidesToShow: sm,
        			        		 slidesToScroll: 1,
        			        		 autoplay: true, 
        			        		 dots: false,
        			        		 arrows: true,
        			        		 speed: 400,
        			        		 autoplaySpeed: 6000,
        		 				}
        		 		},
        		 		{
        		 			breakpoint: 1024, 
        		 				settings: {
        			        		infinite: true,
        			        		slidesToShow: md,
        			        		slidesToScroll: 1,
        			        		autoplay: true, 
        			        		arrows: true,
        			        		dots: false,
        			        		speed: 400,
        			        		autoplaySpeed: 6000,
        		 				}
        		 		}
        		 	]
        	    });
            
        } else {
            
        
	    
	    elem.slick({
		dots: showDots,
		arrows: true,
		infinite: infinite_value,
		draggable: false,
		autoplay: true,
		slidesToShow: lg,
		slidesToScroll: custom_slidesToScroll,
		autoplaySpeed: 6000,
			responsive:[
		 		{
		 			breakpoint: 641, 
		 				settings: {
			        		 infinite: true,
			        		 slidesToShow: sm,
			        		 slidesToScroll: custom_slidesToScroll,
			        		 autoplay: true, 
			        		 dots: showDots,
			        		 arrows: true,
			        		 speed: 400,
			        		 autoplaySpeed: 6000,
		 				}
		 		},
		 		{
		 			breakpoint: 1024, 
		 				settings: {
			        		infinite: true,
			        		slidesToShow: md,
			        		slidesToScroll: custom_slidesToScroll,
			        		autoplay: true, 
			        		arrows: true,
			        		dots: showDots,
			        		speed: 400,
			        		autoplaySpeed: 6000,
		 				}
		 		}
		 	]
	    });
	    
        }
	}
	
	if( jQuery('.carousel .section-body').length > 0 ) {
	    jQuery('.carousel .section-body').each(function(i,v){
	        var elem = jQuery(this);
			var infinite = undefined != elem.attr('data-infinite') ?  elem.attr('data-infinite') : "yes";
	        generate_carousel( elem , elem.attr('data-item-col'), infinite );
	    });
	}

	

	jQuery('.services-video-slider').slick({
		 slidesToShow: 4,
		slidesToScroll: 4,
			responsive:[
		 		{
		 			breakpoint: 641, 
		 				settings: {
			        		 infinite: true,
			        		 slidesToShow: 1,
			        		 slidesToScroll: 1,
			        		 autoplay: true, 
			        		 dots: false,
			        		 arrows: true,
			        		 speed: 400,
			        		 autoplaySpeed: 6000,
		 				}
		 		},
		 		
		 	]
	});

    var layoutTheme = jQuery('.gallery-slide').attr('data-gallery-arrow');
    
	jQuery('.gallery-slide').slick({
		 dots: false,
		 autoplay: true, 
		 infinite: false,
		 arrows: true,
		 slidesToShow: 4,
		 slidesToScroll: 4,
		 speed: 400,
		 autoplaySpeed: 8000,
		 	responsive:[
		 		{
		 			breakpoint: 641, 
		 				settings: {
			        		 infinite: false,
			        		 slidesToShow: 1,
			        		 slidesToScroll: 1,
			        		 autoplay: true, 
			        		 dots: false,
			        		 arrows: true,
			        		 speed: 400,
			        		 autoplaySpeed: 8000,
		 				}
		 		},
		 		{
		 			breakpoint: 1024, 
		 				settings: {
			        		infinite: false,
			        		slidesToShow: 4,
			        		slidesToScroll: 4,
			        		autoplay: true, 
			        		arrows: true,
			        		dots: false,
			        		speed: 400,
			        		autoplaySpeed: 8000,
		 				}
		 		}
		 	]
	});
	
	//content equal height
	equalheight = function(container){

	var currentTallest = 0,
	     currentRowStart = 0,
	     rowDivs = new Array(),
	     el,
	     topPosition = 0;
	 jQuery(container).each(function() {

	   el = jQuery(this);
	   jQuery(el).height('auto')
	   topPostion = el.position().top;

	   if (currentRowStart != topPostion) {
	     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
	       rowDivs[currentDiv].height(currentTallest);
	     }
	     rowDivs.length = 0; // empty the array
	     currentRowStart = topPostion;
	     currentTallest = el.height();
	     rowDivs.push(el);
	   } else {
	     rowDivs.push(el);
	     currentTallest = (currentTallest < el.height()) ? (el.height()) : (currentTallest);
	  }
	   for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
	     rowDivs[currentDiv].height(currentTallest);
	   }
	 });
	}

	jQuery(window).load(function() {
	  	  equalheight('.adaptive, .box-equal-height .hic-content, .box-equal-blurb .hic-blurb, .box-equal-title .hic-title');
	});


	jQuery(window).resize(function(){
	   	  equalheight('.adaptive, .box-equal-height .hic-content, .box-equal-blurb .hic-blurb, .box-equal-title .hic-title');
	});


});

jQuery(document).ready(function($) {



	
	$('#btn_menu_icon').on('click', function() {		
		$('body').toggleClass('menu-open');
	});


	var fancyFplan = $(".floorplan-lightbox [data-fancybox]");

				fancyFplan.attr("rel", "floorplan").fancybox({
					loop: true,
					buttons: [
						//'slideShow',
						'fullScreen',
						'thumbs',
						//'share',
						//'download',
						'zoom',
						'close'
					],
					thumbs: {
						autoStart: true,
						hideOnClose: true,
						axis: "x"
					},
				});

		var fancyMainImage = $(".listing-gallery .image-list:not(.slick-cloned) [data-fancybox]");

				fancyMainImage.attr("rel", "listing-gallery").fancybox({
					loop: false,
					buttons: [
						// 'slideShow',
						'fullScreen',
						'thumbs',
						// 'share',
						// 'download',
						'zoom',
						'close'
					],
					thumbs: {
						autoStart: true,
						hideOnClose: true,
						axis: "x"
					},
				});

	var fancyGallery2= $(".listing-gallery-2 .image-list:not(.slick-cloned) [data-fancybox]");

				fancyGallery2.attr("rel", "listing-gallery-2").fancybox({
					loop: false,
					buttons: [
						// 'slideShow',
						'fullScreen',
						'thumbs',
						// 'share',
						// 'download',
						'zoom',
						'close'
					],
					thumbs: {
						autoStart: true,
						hideOnClose: true,
						axis: "x"
					},
				});

		var fancyFplans = $(".property-item:not(.slick-cloned) .listing-floorplan-lightbox [data-fancybox]");

				fancyFplans.attr("rel", "floorplans").fancybox({
					loop: true,
					buttons: [
						//'slideShow',
						'fullScreen',
						'thumbs',
						//'share',
						//'download',
						'zoom',
						'close'
					],
					thumbs: {
						autoStart: true,
						hideOnClose: true,
						axis: "x"
					},
					 afterLoad : function(instance, current) {
			            instance.update();

			        }
				});

	var maxHeight = 0;

    $(".hic-pricing-table .hic-box").each(function(){
       if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
    });
    
    $(".hic-pricing-table .hic-box").height(maxHeight);
    
    
    var maxHeight = 0;

    $(".hic-pricing-table .hic-blurb").each(function(){
       if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
    });
    
    $(".hic-pricing-table .hic-blurb").height(maxHeight);


    var maxHeight = 0;

    $(".box-equal-height-title .hic-title h3").each(function(){
       if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
    });
    
    $(".box-equal-height-title .hic-title h3").height(maxHeight);


	$('#fullscreenMenu, .fullscreen-menu-overlay .overlay-close').on('click',function () {
		$('.fullscreen-menu-overlay').toggleClass('open');
	});

	$('#ht4-form-btn').on('click', function() {
		$('body').toggleClass('form-active');
	});
	$(window).scroll(function() {
		if ($(this).scrollTop() > 184.375){  
		    $('body').addClass("scrolled");
		  }
		  else{
		    $('body').removeClass("scrolled");
		  }
		});

	 $('.speaker-button').on('click', function() {

	 		var heroVideo = $(".hero video")

	 		$('.speaker-button').toggleClass('active');


	 		if( heroVideo.prop('muted') ) {
				 heroVideo.prop('muted', false);
			 } else {
				heroVideo.prop('muted', true);
			}

	 		
	 });

	 $('.custom-category-filter li').on('click', function() {

	 	var $carCategory = $(this).attr('data-car-cat');
	 	var $details = {};

	 	$details['cat'] = $carCategory;

	 		$.ajax({
				url: obVal['adminUrl'],
				type: 'POST',
				data: {
					action: 'test_ajax_call',
					postdata: $details,
					nonce: obVal['complete_info'],
				},
				success: function( data, textStatus, xhr ) {

					var obj = $.parseJSON(data);

					

					if( obj['success'] ) {
						
						$('#content_roll').html(obj.success.listing);
					} else {
						
						alert('something went wrong please contact site admin');
					}

					
					
				}



			});		

	 });







		  // $('a[href*=#]:not([href=#])').click(function() {
	   //      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') 
	   //          || location.hostname == this.hostname) {
	    
	   //          var target = $(this.hash);
	   //          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
	   //             if (target.length) {
	   //               $('html,body').animate({
	   //                   scrollTop: target.offset().top
	   //              }, 1000);
	   //              return false;
	   //          }
	   //      }
	   //  });




	   	 var items = $('#agents_list .team-list');

            
            $(".tabs").on("change.zf.tabs", function () {
			    $(".home-slider-pp").slick("setPosition");
			});
			
			
    // FAQ show / hide accordion content
	$('.group-button > .menu [id*="faqbtn-"]').on('click', function() {
		$('.group-button > .menu [id*="faqbtn-"].active').removeClass('active');
        
        var clickBtn = $(this);
		clickBtn.addClass('active');

		$('.accordion.active[id*="faq-"]').removeClass('active');

		var targetElement = '.accordion' + clickBtn.attr('target');
		$(targetElement).addClass('active');	
	});

	// TABBED Content show / hide tab content
	$('.tab-group > .menu [id*="tabbtn-"]').on('click', function() {
		$('.tab-group > .menu [id*="tabbtn-"].active').removeClass('active');
        
        var clickTab = $(this);
		clickTab.addClass('active');

		$('.tab-content-wrapper .tab-content.active[id*="tab-content-"]').removeClass('active');

		var targetElement = '.tab-content-wrapper .tab-content' + clickTab.attr('target');
		$(targetElement).addClass('active');	
	});

	//Disable Gravity Form field with disabled class 
	jQuery('.gfield.disabled input').attr('disabled', true);

	// Video Background positioning helper
	jQuery('.flex-video #hero_bgvid').css('top', function(){
		var top = (jQuery(this).height() - jQuery(this).closest('.video-wrap').height()) / 2 * -1; 
		return top + 'px';
	});

	jQuery('.hero .play-button').css('opacity', '1');

	jQuery('.member-details .show-more').on('click', function(){
		jQuery(this).next(".more-details").css("display", "block");
		jQuery(this).css("display", "none");
	});
});	

//Gravity Form Custom jquery 
jQuery(document).on('gform_post_render', function(){
	// code to trigger on AJAX form render
	if(	jQuery('.registration-form').find('.ginput_preview').length > 0 ){

		next_to(3);
		prev_to(1);
		
		if(jQuery('.registration-form').find('.gform_delete').length > 0) {
			var del_btn = jQuery('.registration-form .ginput_preview .gform_delete');
			del_btn.attr('onclick', del_btn.attr('onclick') + 'next_to(2); prev_to(2)')
		}
	} else {
		jQuery('.registration-form').find('input[type="file"]').on('change', function(){
			if(	jQuery('.registration-form').find('.ginput_preview').length > 0 ){
				next_to(2);
				prev_to(2);
			} else {
				next_to(3);
				prev_to(1);
			}
		});
	}

	jQuery('.gform_wrapper').find('.gfield_select').each(function(){
		var select_field = jQuery(this);
		if(!select_field.hasClass('default-set-value') && select_field.val()=="") select_field.addClass('default-set-value');	

		if(select_field.on('change', function(){
			if(select_field.val()==""){
				if(!select_field.hasClass('default-set-value')) select_field.addClass('default-set-value');	
			} else select_field.removeClass('default-set-value');
		}));
	});

	// remove gravity form input mask underscore
	jQuery('.gfield.clear-mask').each(function(){
	    var e = jQuery(this);
	    var zipcodefield = e.hasClass('postcode');
	    var phonefield = e.hasClass('phone');
	    var form_id = e.closest('form').attr('id');
	    
	    if(form_id){
	        form_id = form_id.replace("gform_", "") ;
	        var field_id = e.attr('id');
	        
	        if(field_id){
	            field_id = field_id.replace("field_" + form_id + "_", "");
	            
	            if(zipcodefield){
        	        jQuery('#input_' + form_id + '_' + field_id).mask( '9999', { placeholder: '' } );
        	    }
        	    
        	    if(phonefield){
        	        jQuery('#input_' + form_id + '_' + field_id).mask( '9999999999', { placeholder: '' } );
        	    }
	        }
	    }
    });

});

function next_to(page){
	jQuery('.registration-form input.button.gform_next_button').attr('onclick', 'registration_goto_page(' + page + ');');
	jQuery('.registration-form input.button.gform_next_button').attr('onkeypress', 'registration_goto_page_on_key_press(' + page + ');');
}
function prev_to(page){
	jQuery('.registration-form input.button.gform_previous_button').attr('onclick', 'registration_goto_page(' + page + ');');
	jQuery('.registration-form input.button.gform_previous_button').attr('onkeypress', 'registration_goto_page_on_key_press(' + page + ');');
}

function registration_goto_page(page) {
	jQuery('.registration-form [id*="gform_target_page_number_').val(page);  
	jQuery('.registration-form[id*="gform_"]').trigger('submit',[true]); 
}

function registration_goto_page_on_key_press(page) {
	if( event.keyCode == 13 ){
		jQuery('.registration-form [id*="gform_target_page_number_').val(page);  
		jQuery('.registration-form[id*="gform_"]').trigger('submit',[true]);
	} 
}